export default __webpack_public_path__ + "img/income-icon.6efeab82.svg";